"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _botframeworkWebchatComponent = require("botframework-webchat-component");

var _AdaptiveCardBuilder = _interopRequireDefault(require("./AdaptiveCardBuilder"));

var _AdaptiveCardRenderer = _interopRequireDefault(require("./AdaptiveCardRenderer"));
/* eslint no-magic-numbers: ["error", { "ignore": [25, 75] }] */


var ThumbnailCardAttachment =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(ThumbnailCardAttachment, _React$Component);

  function ThumbnailCardAttachment(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ThumbnailCardAttachment);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ThumbnailCardAttachment).call(this, props));
    _this.buildCard = (0, _memoizeOne.default)(function (adaptiveCards, content, styleOptions) {
      var builder = new _AdaptiveCardBuilder.default(adaptiveCards, styleOptions);
      var TextSize = adaptiveCards.TextSize,
          TextWeight = adaptiveCards.TextWeight;
      var buttons = content.buttons,
          images = content.images,
          subtitle = content.subtitle,
          text = content.text,
          title = content.title;
      var richCardWrapTitle = styleOptions.richCardWrapTitle;

      if (images && images.length) {
        var _builder$addColumnSet = builder.addColumnSet([75, 25]),
            _builder$addColumnSet2 = (0, _slicedToArray2.default)(_builder$addColumnSet, 2),
            firstColumn = _builder$addColumnSet2[0],
            lastColumn = _builder$addColumnSet2[1];

        var _images = (0, _slicedToArray2.default)(images, 1),
            _images$ = _images[0],
            tap = _images$.tap,
            url = _images$.url;

        builder.addTextBlock(title, {
          size: TextSize.Medium,
          weight: TextWeight.Bolder,
          wrap: richCardWrapTitle
        }, firstColumn);
        builder.addTextBlock(subtitle, {
          isSubtle: true,
          wrap: richCardWrapTitle
        }, firstColumn);
        builder.addImage(url, lastColumn, tap);
        builder.addTextBlock(text, {
          wrap: true
        });
        builder.addButtons(buttons);
      } else {
        builder.addCommon(content);
      }

      return builder.card;
    });
    return _this;
  }

  (0, _createClass2.default)(ThumbnailCardAttachment, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          adaptiveCardHostConfig = _this$props.adaptiveCardHostConfig,
          adaptiveCards = _this$props.adaptiveCards,
          _this$props$attachmen = _this$props.attachment;
      _this$props$attachmen = _this$props$attachmen === void 0 ? {} : _this$props$attachmen;
      var content = _this$props$attachmen.content,
          options = _this$props.styleSet.options;
      return _react.default.createElement(_AdaptiveCardRenderer.default, {
        adaptiveCard: content && this.buildCard(adaptiveCards, content, options),
        adaptiveCardHostConfig: adaptiveCardHostConfig,
        tapAction: content && content.tap
      });
    }
  }]);
  return ThumbnailCardAttachment;
}(_react.default.Component);

ThumbnailCardAttachment.propTypes = {
  adaptiveCardHostConfig: _propTypes.default.any.isRequired,
  adaptiveCards: _propTypes.default.any.isRequired,
  attachment: _propTypes.default.shape({
    content: _propTypes.default.shape({
      buttons: _propTypes.default.array,
      images: _propTypes.default.arrayOf(_propTypes.default.shape({
        tap: _propTypes.default.any,
        url: _propTypes.default.string.isRequired
      })),
      subtitle: _propTypes.default.string,
      tap: _propTypes.default.any,
      text: _propTypes.default.string,
      title: _propTypes.default.string
    }).isRequired
  }).isRequired
};

var _default = (0, _botframeworkWebchatComponent.connectToWebChat)(function (_ref) {
  var styleSet = _ref.styleSet;
  return {
    styleSet: styleSet
  };
})(ThumbnailCardAttachment);

exports.default = _default;